(()=>{
  const body=document.body;
  const onScroll=()=>body.classList.toggle('oe-page-scrolled',window.scrollY>18);
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  const bindLiquid=scope=>{
    (scope||document).querySelectorAll('.oe-liquid-button,.product-buttons-add-to-cart,.sticky-atc .btn').forEach(el=>{
      if(el.dataset.oeLiquidReady)return;
      el.dataset.oeLiquidReady='true';
      el.addEventListener('pointermove',e=>{
        const r=el.getBoundingClientRect();
        el.style.setProperty('--oe-x',`${(e.clientX-r.left)/r.width*100}%`);
        el.style.setProperty('--oe-y',`${(e.clientY-r.top)/r.height*100}%`);
      },{passive:true});
    });
  };

  const cleanNavigation=scope=>{
    (scope||document).querySelectorAll('#header-desktop-menu .nav-link,#header-mobile-menu .nav-link').forEach(el=>{
      if(el.textContent.trim()==='|'){
        const item=el.closest('.nav-item');
        if(item)item.hidden=true;
      }
    });
  };

  const cleanDemoSocials=scope=>{
    (scope||document).querySelectorAll('.social-icons a[href]').forEach(a=>{
      const href=a.getAttribute('href')||'';
      if(href==='https://www.instagram.com/shopify'){
        a.setAttribute('href','https://www.instagram.com/empireopulent');
        a.setAttribute('aria-label','Instagram — @empireopulent');
        return;
      }
      if(href.includes('shopify')){
        const li=a.closest('li');
        if(li)li.hidden=true;
      }
    });
  };

  const normalizeChooseOptions=scope=>{
    const root=scope&&scope.querySelectorAll?scope:document;
    root.querySelectorAll('.product-card-find-size,.product-card a.btn').forEach(button=>{
      const span=button.querySelector('span');
      if(span&&span.textContent.trim().toLowerCase()==='find size'){
        span.textContent='Choose options';
      }else if(!span&&button.textContent.trim().toLowerCase()==='find size'){
        button.textContent='Choose options';
      }
      const label=button.getAttribute('aria-label');
      if(label&&/find size/i.test(label)){
        button.setAttribute('aria-label',label.replace(/find size/gi,'Choose options'));
      }
    });
  };

  const enhance=scope=>{
    bindLiquid(scope);
    cleanNavigation(scope);
    cleanDemoSocials(scope);
    normalizeChooseOptions(scope);
  };

  enhance(document);

  document.addEventListener('shopify:section:load',e=>enhance(e.target));
  document.addEventListener('collection:products-updated',()=>normalizeChooseOptions(document));

  const observer=new MutationObserver(mutations=>{
    for(const mutation of mutations){
      for(const node of mutation.addedNodes){
        if(!(node instanceof Element))continue;
        if(node.matches('.product-card-find-size')||node.querySelector('.product-card-find-size')||node.matches('.product-card')||node.querySelector('.product-card')){
          normalizeChooseOptions(node.matches('.product-card-find-size')?node.parentElement||document:node);
        }
      }
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
